export default __webpack_public_path__ + "static/media/9.9b484e43.svg";